/* eslint-disable react/require-default-props */
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Extensions } from '@powdr/constants';
import { getFileExtension } from '@powdr/utils';

import {
  StyledOrderedShowcaseItem, ShowcaseItem, ImageWrapper, Image,
} from './styles';

export const OrderedShowcaseItem = ({
  className = '',
  active,
  relationships = {},
}) => {
  const [lottie, setLottie] = useState(null);
  const showcaseIconData = relationships?.showcaseIcon || null;
  const fileExtension = getFileExtension(showcaseIconData?.filename);

  return (
    <StyledOrderedShowcaseItem className={className}>
      <ImageWrapper>
        {(fileExtension === Extensions.JSON || fileExtension === Extensions.LOTTIE) ? (
          <DotLottieReact
            dotLottieRefCallback={setLottie}
            src={showcaseIconData.publicUrl}
            loop={!!active}
            autoplay={!!(active)}
            renderConfig={{
              autoResize: true,
            }}
          />
        ) : (
          <Image alt="" src={showcaseIconData.url} />
        )}
      </ImageWrapper>
    </StyledOrderedShowcaseItem>
  );
};

OrderedShowcaseItem.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  relationships: PropTypes.shape({}),
};
